import styles from './Feedback.module.css'
import emailjs from 'emailjs-com'
import { useState } from 'react'
import { useAuthContext } from '../../hooks/useAuthContext'


export default function Feedback() {
  const { user, customClaims } = useAuthContext()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [message, setMessage] = useState('')

  function sendEmail(e) {
	e.preventDefault()
  setIsSubmitting(true)
  setMessage('')

	emailjs.sendForm (
    'service_dx1jzia', 
    'template_b0iykln', 
    e.target, 
    'VjAJQ4IhbLSdqEL5z'
  )
    .then((result) => {
      setMessage('✅ Feedback sent successfully! Thank you.')
      e.target.reset()  // clear the form
    })
	  .catch((err) => {
      setMessage('❌ Failed to send feedback. Please try again.')
      console.error('EmailJS error :', err)
    })
    .finally(() => setIsSubmitting(false))
  }

  return (
    <div className="main">
      <div className={styles['feedback']}>
        <div className="paragraph">
          <h1>We Value Your Feedback</h1>
          <p>Your insights help us build a better Crifty. Whether you're reporting an 
            issue or suggesting an improvement, we’re committed to delivering a seamless 
            and intuitive experience for every user.</p>
          <form onSubmit={sendEmail}>
            <input 
              type="hidden" 
              name="name" 
              value={user?.displayName || ''} />
            <input 
              type="hidden" 
              name="email" 
              value={user?.email || ''} />
            <input 
              type="text"
              name="title"
              placeholder="Title"
              required
            />
            <textarea 
              name="message" 
              placeholder="Your Feedback" 
              required />
            <button 
              className="btn" 
              disabled={isSubmitting}
              type="submit">
                Send Feedback
            </button>
            {message && <span>{message}</span>}

          </form>
        </div>

      </div>
      
      
    </div>
  )
}
